import {Measure, temperature, TemperatureSystems} from "convert-units";

type NewTemperatureUnits = 'F' | 'K' | 'R' | 'ºC';

const newTemperature: Measure<TemperatureSystems, NewTemperatureUnits> = {
  systems: {
    metric: {
      'ºC': {
        name: {
          singular: 'degree Celsius',
          plural: 'degrees Celsius',
        },
        to_anchor: 1,
        anchor_shift: 0,
      },
      K: {
        name: {
          singular: 'degree Kelvin',
          plural: 'degrees Kelvin',
        },
        to_anchor: 1,
        anchor_shift: 273.15,
      },
    },
    imperial: {
      ...temperature.systems.imperial,
    },
  },
  anchors: {
    ...temperature.anchors,
  }
};

export default newTemperature;
